import { Intent } from 'enums';
import React from 'react';
import { LinkProps } from 'react-router-dom';

import { HrefLink as BaseLink } from './styles';

export interface IProps extends React.RefAttributes<HTMLAnchorElement> {
  /**
   * Flag indicating that the active state should be used be default (e.g. hover state)
   * @default false
   */
  active?: boolean;
  /**
   * Children
   */
  children?: React.ReactNode;
  /**
   * The intent applied to the link
   * @default Intent.NONE
   */
  intent?: Intent;
  /**
   * Controls if the link is disabled
   */
  isDisabled?: boolean;
}

const HrefLink = ({
  active,
  intent = Intent.NONE,
  isDisabled = false,
  children,
  className,
  onClick,
  ...props
}: IProps & Partial<LinkProps>) => {
  return (
    <BaseLink
      $intent={intent}
      $active={active}
      {...props}
      className={className}
      $isDisabled={isDisabled}
      onClick={isDisabled ? undefined : onClick}
    >
      {children}
    </BaseLink>
  );
};

export default HrefLink;
